export const maxRetries = 2;

export const paginationSize = 20;
